<template>
  <template v-for="(show, name) in slots">
    <slot
      v-if="show"
      v-bind="$attrs"
      :name/>
  </template>
</template>

<script setup>
import useExperiment from '@shared/composables/experiment.js'
import { toPascalCase } from '@/utils/stringParsing.js' // TODO: ENG-3647 - Isolate shared code.
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

const experiment = useExperiment(props.name)

/** @type {import('vue').ComputedRef<{[key: string]: boolean}>} */
const slots = computed(() =>
  experiment.variantNames.value.reduce((acc, variantName) => {
    const variantNamePascal = toPascalCase(variantName)
    acc[variantName] = experiment[`showVariant${variantNamePascal}`].value
    acc[`variant${variantNamePascal}`] = acc[variantName] // Backwards compatibility
    return acc
  }, { default: experiment.showOriginal.value })
)
</script>
